import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NDBSQuickOrderComponent } from './ndbs-quick-order.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SearchProductModule } from '../../../../components/search-product/search-product.module';
import { PageTitle } from '../../store-front/misc/page-title/page-title.component';
import { QuickOrderProductListComponent } from './components/quick-order-product-list/quick-order-product-list.component';
import { ImportEntriesComponent } from '../import-export/components/import-entries/import-entries.component';
import { CustomExportOrderEntriesModule } from '../import-export/components/export-entries';

@NgModule({
  declarations: [NDBSQuickOrderComponent],
  imports: [
    CommonModule,
    I18nModule,
    PageTitle,
    SearchProductModule,
    QuickOrderProductListComponent,
    I18nModule,
    ImportEntriesComponent,
    CustomExportOrderEntriesModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        NDBSQuickOrderComponent: {
          component: NDBSQuickOrderComponent,
          guards: [AuthGuard],
        },
      },
    }),
  ],
})
export class NDBSQuickOrderModule {}
